import axios from 'axios';
import { method } from 'lodash';
import { authHeaders } from './authServices';

export const fetchUser = (email, password) => {
  return axios({
    method: 'post',
    headers: {
      'Access-Control-Allow-Origin': '*',
    },
    url: `${process.env.REACT_APP_DEV_URL}/api/auth/login`,
    data: { email, password },
  });
};

export const getUser = (token) => {
  return axios({
    method: 'get',
    ...authHeaders(token),
    url: `${process.env.REACT_APP_DEV_URL}/api/auth/user`,
  });
};

export const editUser = (id, editedUser) => {
  return axios({
    method: 'post',
    ...authHeaders(),
    url: `${process.env.REACT_APP_DEV_URL}/api/auth/edit/${id}`,
    data: { ...editedUser },
  });
};
